import React from 'react'
import {MemberVerifyIdentityInfo} from '../../../../DTO/MemberVerifyIdentityInfoDTO'
import {ContentBlock} from '../../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../../Molecules/BaseContentBlocks/ContentTopMessage'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {MBContentBodyTypography, MBContentSubTitleTypography} from '../../../Atoms/Typographies'
import {ColumnFlexContainer} from '../../../Atoms/Containers'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {useTranslation} from 'react-i18next'

type MemberRegisterInfoContentProps = {
  memberInfo: MemberVerifyIdentityInfo
}
export const ConfirmRegistrationContent: React.VFC<MemberRegisterInfoContentProps> = (props) => {
  const {t} = useTranslation('member')

  return (
    <ContentBlock data-testid={'block-confirm-registration'}>
      <ContentTitle>{t('パスワード再設定.登録情報.見出し')}</ContentTitle>
      <ContentTopMessage>{t('パスワード再設定.登録情報.説明')}</ContentTopMessage>
      <Spacer>
        <Spacer mb={'18px'}>
          <MBContentBodyDivider/>
        </Spacer>
        <ColumnFlexContainer gap={'10px'}>
          <MBContentSubTitleTypography>お名前</MBContentSubTitleTypography>
          <MBContentBodyTypography>{`${props.memberInfo.name} さん`}</MBContentBodyTypography>
        </ColumnFlexContainer>
        <Spacer my={'18px'}>
          <MBContentBodyDivider/>
        </Spacer>
        <ColumnFlexContainer gap={'10px'}>
          <MBContentSubTitleTypography>
            {t('パスワード再設定.登録情報.ラベル メールアドレス')}
          </MBContentSubTitleTypography>
          <MBContentBodyTypography>{props.memberInfo.mail}</MBContentBodyTypography>
        </ColumnFlexContainer>
        <Spacer mt={'18px'}>
          <MBContentBodyDivider/>
        </Spacer>
      </Spacer>
    </ContentBlock>
  )
}
